module.exports = __webpack_public_path__ + "images/61392e7a015237a63b2e83e652cf2a95-logo_white.png";